
class NotFoundError extends Error {
}

export default NotFoundError;
